import { ILegalClient } from '../../../Interfaces/ILegalClient';
import { ILegalTransactionMeeting } from '../../../Interfaces/ILegalTransactionMeeting';
import { ITalkParticipant } from '../../../Interfaces/ITalkParticipant';

export const getLegalClientLabel = (legalClient: ILegalClient) =>
  [legalClient.FirstName, legalClient.LastName]
    .filter(Boolean)
    .join(' ')
    .trim() ||
  legalClient.Email ||
  `Mandant #${legalClient.idLegalClient}`;

export const getInvitedMeetingLegalClients = (
  meetings: ILegalTransactionMeeting[],
  talkRoomId: number
): ILegalClient[] => {
  const invitedById = new Map<number, ILegalClient>();

  for (const meeting of meetings) {
    if (meeting.idLegalTransactionTalkRoom !== talkRoomId) {
      continue;
    }

    for (const legalClient of meeting.LegalClientArray ?? []) {
      invitedById.set(legalClient.idLegalClient, legalClient);
    }
  }

  return Array.from(invitedById.values());
};

const isBusinessTalkParticipant = (participant: ITalkParticipant) => {
  // participantType 1 = Owner (der Nextcloud-Serviceaccount, der Räume erstellt)
  // Er ist immer im Raum, kann nicht entfernt werden und soll nicht angezeigt werden.
  if (participant.participantType === 1) {
    return false;
  }

  const actorType = participant.actorType.trim().toLowerCase();
  if (actorType === 'emails') {
    return Boolean(participant.invitedActorId);
  }

  if (actorType === 'users') {
    return Boolean(
      (participant.displayName && participant.displayName.trim()) ||
        (participant.actorId && participant.actorId.trim())
    );
  }

  return false;
};

export const getVisibleTalkParticipants = (
  participants: ITalkParticipant[]
) => participants.filter(isBusinessTalkParticipant);

export const getTalkParticipantLabel = (participant: ITalkParticipant) => {
  const actorType = participant.actorType.trim().toLowerCase();

  if (actorType === 'emails') {
    return participant.invitedActorId || participant.displayName || participant.actorId;
  }

  return participant.displayName || participant.actorId;
};

export const getTalkParticipantSecondaryLabel = (
  participant: ITalkParticipant
) => {
  const actorType = participant.actorType.trim().toLowerCase();
  return actorType === 'emails' ? 'Externer Talk-Teilnehmer' : 'Interner Talk-Teilnehmer';
};
